/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const t={test:t=>"auto"===t,parse:t=>t};export{t as auto};
//# sourceMappingURL=type-auto.js.map
